import React, { useState, useEffect } from 'react'
import { CommunityLeadsBusinessValidation } from '../../Validations'
import { businessTypeArray, natureOfServiceArr, loanForArray, typeOfBusinessArr, typeOfConsititutionArr, WEBSITE } from '../../CommonUtils'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../CommonComponents/PiePage.component'
// import Routes from '../../../../Layout/Routes'
import { CommunityLeadSaveUserBusinessApi, CommunityLeadGetUserBusinessApi } from './AddLeadActionCreator'
import InputField from '../../CommonComponents/InputMUI'
import SelectField from '../../CommonComponents/SelectMUI'
import CheckBoxField from '../../CommonComponents/CheckboxMUI'
// import DatePicker from '../../../common/DatePickerMUI'
import moment from 'moment'
import { TextareaAutosize } from '@mui/material'

const AddUi = ({data,handlePage,handleTab}) => {
    const [objectData, setObjectData] = useState({
        loanFor: '', designation: '', typeOfBusiness: '', typeOfConsititution: '', businessDesc: '',
        quaterlyTurnover: '', lastYearTurnover: '', dateOfIncorporation: '', tradeLicenseNoOrMSME: '',
        gstNo: '', cinLlpin: '', orgPanNo: ''
        // name: '', nameOfBusiness: '', businessType: "", natureOfService: '',
        // businessPinCode: "", yearOfBusiness: '', lastYearTurnover: '',
        // tillDateTurnOver: '', gstNo: '', gstRegistrationCertificate: false, msmeAvailable: false
    })
    const [message, setMessage] = useState({})
    const [loaderState, setLoaderState] = useState(false)
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // console.log('hello buisness')
        if (data !== null && data.rowData !== undefined) {
            let changeObjectData = { ...objectData }
            changeObjectData.userId = data.rowData.userId
            if (data.rowData.loanId !== undefined) {
                changeObjectData.loanId = data.rowData.loanId
            }
            setObjectData(changeObjectData)
            getDetail(changeObjectData)
        }
    }, [])

    const getDetail = (data) => {
        CommunityLeadGetUserBusinessApi(data.rowData.userId,
            callBack => {
                if (Object.keys(callBack).length > 0) {
                    let changeObjectData = Object.assign({}, data)
                    Object.keys(callBack).forEach(key => {
                        if (callBack[key] !== null && callBack['id'] !== 0) {
                            changeObjectData[key] = callBack[key]
                        }
                    });
                    setObjectData(changeObjectData)
                }
            }, error => {

            })
    }

    const inputChange = (e, type) => {
        let changeObjectData = Object.assign({}, objectData)
        if (type === 'dateOfIncorporation') {
            // changeObjectData[type] = moment(e).format('YYYY-MM-DDThh:mm:ssZ')
            changeObjectData[type] = e
        } else if (type !== 'dateOfIncorporation' && type !== 'quaterlyTurnover' && type !== 'lastYearTurnover') {
            changeObjectData[type] = e
        }
        if (type === 'businessDesc') {
            if (e.length <= 200) {
                changeObjectData[type] = e.target.value
            } else {
                changeObjectData[type] = e.target.value.slice(0, 200)

            }
        }
        if (type === 'quaterlyTurnover' || type === 'lastYearTurnover') {

            if (e.length <= 10) {
                changeObjectData[type] = e
            } else {
                changeObjectData[type] = e.slice(0, 10)

            }
        }
        if (type === 'gstNo') {
            if (e.length > 15) {
                e = e.slice(0, 15)
                // console.log(typeof (e))

                changeObjectData[type] = e
            }
        }
        setObjectData(changeObjectData)
        setMessage({})
    }

    const saveHandler = (e) => {
        if (e === 'save') {
            let validationMsg = CommunityLeadsBusinessValidation(objectData)
            // console.log(validationMsg)
            if (validationMsg.status) {
                setMessage(validationMsg)
                setLoaderState(true)
                CommunityLeadSaveUserBusinessApi(objectData,
                    callBack => {
                        if (data.rowData.loanId !== undefined) {
                            callBack.loanId = data.rowData.loanId
                        }
                        callBack.sourceOfIncome = data.rowData.sourceOfIncome
                        // navigate(Routes.COMMUNITY_ADD_LEAD_ADDRESS, { state: { rowData: callBack } })
                        if (!window.location.href.includes("/external")) {
                            const obj ={
                                owData: callBack,
                                 communityId: data ? data.communityId : null,
                                  qrId: data ? data.qrId : null 
                            }
                            handleTab("addLeadDirector",obj)
                            // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_DIRECTOR : Routes.COMMUNITY_ADD_LEAD_DIRECTOR, { state: { rowData: callBack, communityId: data ? data.communityId : null, qrId: data ? data.qrId : null } })
                        }
                       
                        setLoaderState(false)
                    },
                    error => {
                        setLoaderState(false)
                    })
            } else {
                setMessage(validationMsg)
            }
        } else if (e === 'close') {

            // if (data ? data.communityId : null) {
            //     let data = data.rowData
            //     data.communityId = data ? data.communityId : null
            //     navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: data, page: 'communityLeads' } })
            // } else if (data ? data.qrId : null) {
            //     let data = data.rowData
            //     data.qrId = data ? data.qrId : null
            //     navigate(Routes.SUPER_ADMIN_QR_DETAILS, { state: { rowData: data, page: 'leads' } })
            // } else {
            //     navigate(window.location.href.includes('admin') ? Routes.SUPER_ADMIN_ALL_LEADS : Routes.COMMUNITY_ALL_LEADS)
            // }
            handlePage("","list")
        } else if (e === 'back') {
            const obj={
                rowData: objectData, 
                communityId: data ? data.communityId:null
            }
            handleTab("personal",obj)
            // if (!window.location.href.includes('/external')) {
            //     navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_PERSONAL : Routes.COMMUNITY_ADD_LEAD_PERSONAL, { state: { rowData: objectData, communityId: data ? data.communityId : null } })
            // } else {
            //     navigate(Routes.EXTERNAL_COMMUNITY_ADD_LEAD_PERSONAL, { state: { rowData: objectData } })
            // }
        }
    }

    // console.log(objectData)

    return (
        <div className='container hoverNone card'>
            {loaderState ?
                <Loader />
                : null}
            <PiePage
                totalPage={5}
                currentPage={2}
                heading={'Add Business Info'}
            />
            <div className=' row' style={{marginBottom:'12px'}}>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <SelectField
                        label={'Loan For'}
                        onChange={e => inputChange(e, 'loanFor')}
                        id="loanFor"
                        value={objectData.loanFor}
                        name="loanFor"
                        data={loanForArray}
                        size={'small'}
                    // required={true}
                    />
                    <div id="loanForHelp" className="form-text text-danger">{message.field === 'loanFor' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Designation"
                        variant="outlined"
                        value={objectData.designation}
                        name="designation"
                        id="designation"
                        type="text"
                        onChange={e => inputChange(e, 'designation')}
                        size="small"
                    // required={true}
                    />
                    <div id="designationHelp" className="form-text text-danger">{message.field === 'designation' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <SelectField
                        label={'Type Of Business'}
                        onChange={e => inputChange(e, 'typeOfBusiness')}
                        id="typeOfBusiness"
                        value={objectData.typeOfBusiness}
                        name="typeOfBusiness"
                        data={typeOfBusinessArr}
                        size={'small'}
                    // required={true}
                    />
                    <div id="typeOfBusinessHelp" className="form-text text-danger">{message.field === 'typeOfBusiness' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <SelectField
                        label={'Type Of Constitution'}
                        onChange={e => inputChange(e, 'typeOfConsititution')}
                        id="typeOfConsititution"
                        value={objectData.typeOfConsititution}
                        name="typeOfConsititution"
                        data={typeOfConsititutionArr}
                        size={'small'}
                        required={true}
                    />
                    <div id="typeOfConsititutionHelp" className="form-text text-danger">{message.field === 'typeOfConsititution' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-12 col-xs-12'>
                    <label style={{
                        fontSize: '13px',
                        color: '#00000099'
                    }}>Business Description (200 Words)
                        {/* <span style={{color:'red',fontSize:'17px'}}>*</span> */}
                    </label>
                    <TextareaAutosize

                        className='text-area-class'
                        placeholder="type here..."
                        variant="outlined"
                        value={objectData.businessDesc}
                        name="businessDesc"
                        id="businessDesc"
                        type="text"
                        onChange={e => inputChange(e, 'businessDesc')}
                        size="small"
                        // required={true}
                        style={{ width: '100%', border: 'none', borderBottom: '1px solid gray', maxHeight: '250px', overflow: 'scroll', height: '100px' }}
                    />
                    <span style={{ color: '#00000099' }} >{objectData.businessDesc.length > 0 ? objectData.businessDesc.length + '/200' : ""}</span>
                    <div id="businessDescHelp" className="form-text text-danger">{message.field === 'businessDesc' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Latest Quaterly Turnover"
                        variant="outlined"
                        value={objectData.quaterlyTurnover}
                        name="quaterlyTurnover"
                        id="quaterlyTurnover"
                        type="number"
                        onChange={e => inputChange(e, 'quaterlyTurnover')}
                        size="small"
                    // required={true}
                    />
                    <div id="quaterlyTurnoverHelp" className="form-text text-danger">{message.field === 'quaterlyTurnover' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Last Year Turnover"
                        variant="outlined"
                        value={objectData.lastYearTurnover}
                        name="lastYearTurnover"
                        id="lastYearTurnover"
                        type="number"
                        onChange={e => inputChange(e, 'lastYearTurnover')}
                        size="small"
                    // required={true}
                    />
                    <div id="lastYearTurnoverHelp" className="form-text text-danger">{message.field === 'lastYearTurnover' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    {/* <DatePicker
                        label="Date Of Incorporation / Formation"
                        // format={'MM/dd/yyyy'}
                        value={objectData.dateOfIncorporation}
                        name="dateOfIncorporation"
                        size="small"
                        onChange={e => inputChange(e, 'dateOfIncorporation')}
                        required={true}
                    /> */}
                    <InputField

                        value={objectData.dateOfIncorporation ? objectData.dateOfIncorporation : moment(new Date).format("YYYY-MM-DD")}
                        label="Date Of Incorporation / Formation"
                        // format={'MM/dd/yyyy'}
                        name="dateOfIncorporation"
                        size="small"
                        onChange={e => inputChange(e, 'dateOfIncorporation')}
                        required={true}
                    // required={true}
                    />
                    <div id="dateOfIncorporationHelp" className="form-text text-danger">{message.field === 'dateOfIncorporation' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12'style={{marginBottom:'12px'}}>
                    <InputField
                        label="GST Number"
                        variant="outlined"
                        value={objectData.gstNo}
                        name="gstNo"
                        id="gstNo"
                        type="text"
                        onChange={e => inputChange(e, 'gstNo')}
                        size="small"
                    />
                    <div id="gstNoHelp" className="form-text text-danger">{message.field === 'gstNo' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Trade License No Or MSME Registration No"
                        variant="outlined"
                        value={objectData.tradeLicenseNoOrMSME}
                        name="tradeLicenseNoOrMSME"
                        id="tradeLicenseNoOrMSME"
                        type="text"
                        onChange={e => inputChange(e, 'tradeLicenseNoOrMSME')}
                        size="small"
                    />
                    {/* <div id="tradeLicenseNoOrMSMEHelp" className="form-text text-danger">{message.field === 'tradeLicenseNoOrMSME' ? message.msg : ""}</div> */}
                </div>
                {objectData.typeOfConsititution === 'privatelimited' || objectData.typeOfConsititution === 'llp' ?
                    <div className=' col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                        <InputField
                            label="CIN / LLPIN"
                            variant="outlined"
                            value={objectData.cinLlpin}
                            name="cinLlpin"
                            id="cinLlpin"
                            type="text"
                            onChange={e => inputChange(e, 'cinLlpin')}
                            size="small"
                        />
                        <div id="cinLlpinHelp" className="form-text text-danger">{message.field === 'cinLlpin' ? message.msg : ""}</div>
                    </div>
                    : null}
                {objectData.typeOfConsititution === 'privatelimited' || objectData.typeOfConsititution === 'llp' || objectData.typeOfConsititution === 'partnership' ?
                    <div className=' col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                        <InputField
                            label="Organization PAN No"
                            variant="outlined"
                            value={objectData.orgPanNo}
                            name="orgPanNo"
                            id="orgPanNo"
                            type="text"
                            onChange={e => inputChange(e, 'orgPanNo')}
                            size="small"
                        />
                        <div id="orgPanNoHelp" className="form-text text-danger">{message.field === 'orgPanNo' ? message.msg : ""}</div>
                    </div>
                    : null}
                {/* <div className='mb-3 col-sm-6 col-xs-12'>
                    <InputField
                        label="Name of Business"
                        variant="outlined"
                        value={objectData.nameOfBusiness}
                        name="nameOfBusiness"
                        id="nameOfBusiness"
                        type="text"
                        onChange={e => inputChange(e, 'nameOfBusiness')}
                        size="small"
                        required={true}
                    />
                    <div id="nameOfBusinessHelp" className="form-text text-danger">{message.field === 'nameOfBusiness' ? message.msg : ""}</div>
                </div>
                <div className='mb-3 col-sm-6 col-xs-12'>
                    <SelectField
                        label={'Nature Of Bussiness / Profession'}
                        onChange={e => inputChange(e, 'businessType')}
                        id="businessType"
                        value={objectData.businessType}
                        name="businessType"
                        data={businessTypeArray}
                        size={'small'}
                        required={true}
                    />
                    <div id="businessTypeHelp" className="form-text text-danger">{message.field === 'businessType' ? message.msg : ""}</div>
                </div>
                <div className='mb-3 col-sm-6 col-xs-12'>
                    <InputField
                        label="Business PinCode"
                        variant="outlined"
                        value={objectData.businessPinCode}
                        name="businessPinCode"
                        id="businessPinCode"
                        type="number"
                        onChange={e => inputChange(e, 'businessPinCode')}
                        size="small"
                        required={true}
                    />
                    <div id="businessPinCodeHelp" className="form-text text-danger">{message.field === 'businessPinCode' ? message.msg : ""}</div>
                </div>
                <div className='mb-3 col-sm-6 col-xs-12'>
                    <InputField
                        label="Year Of Business"
                        variant="outlined"
                        value={objectData.yearOfBusiness}
                        name="yearOfBusiness"
                        id="yearOfBusiness"
                        type="number"
                        onChange={e => inputChange(e, 'yearOfBusiness')}
                        size="small"
                        required={true}
                    />
                    <div id="yearOfBusinessHelp" className="form-text text-danger">{message.field === 'yearOfBusiness' ? message.msg : ""}</div>
                </div>
                <div className='mb-3 col-sm-6 col-xs-12'>
                    <InputField
                        label="Last Year Turnover"
                        variant="outlined"
                        value={objectData.lastYearTurnover}
                        name="lastYearTurnover"
                        id="lastYearTurnover"
                        type="number"
                        onChange={e => inputChange(e, 'lastYearTurnover')}
                        size="small"
                        required={true}
                    />
                    <div id="lastYearTurnoverHelp" className="form-text text-danger">{message.field === 'lastYearTurnover' ? message.msg : ""}</div>
                </div>
                <div className='mb-3 col-sm-6 col-xs-12'>
                    <InputField
                        label="Till Date Turnover"
                        variant="outlined"
                        value={objectData.tillDateTurnOver}
                        name="tillDateTurnOver"
                        id="tillDateTurnOver"
                        type="number"
                        onChange={e => inputChange(e, 'tillDateTurnOver')}
                        size="small"
                        required={true}
                    />
                    <div id="tillDateTurnOverHelp" className="form-text text-danger">{message.field === 'tillDateTurnOver' ? message.msg : ""}</div>
                </div>
                <div className='mb-3 col-sm-6 col-xs-12'>
                    <SelectField
                        label={'Nature Of Service'}
                        onChange={e => inputChange(e, 'natureOfService')}
                        id="natureOfService"
                        value={objectData.natureOfService}
                        name="natureOfService"
                        data={natureOfServiceArr}
                        size={'small'}
                        required={true}
                    />
                    <div id="natureOfService Help" className="form-text text-danger">{message.field === 'natureOfService ' ? message.msg : ""}</div>
                </div>
                <div className='mb-3 col-sm-6 col-xs-12'>
                    <InputField
                        label="GST Number"
                        variant="outlined"
                        value={objectData.gstNo}
                        name="gstNo"
                        id="gstNo"
                        type="text"
                        onChange={e => inputChange(e, 'gstNo')}
                        size="small"
                    />
                    <div id="gstNoHelp" className="form-text text-danger">{message.field === 'gstNo' ? message.msg : ""}</div>
                </div> */}
                <div className='col-sm-6 col-xs-12'></div>
                {/* {objectData.businessType === 'Partnership' || objectData.businessType === 'Sole Proprietorship' ?
                    <div className='col-xs-12'>
                        <CheckBoxField
                            label={'GST Registration Certificate'}
                            checked={objectData.gstRegistrationCertificate}
                            onChange={e => inputChange(e, 'gstRegistrationCertificate')}
                        />
                    </div>
                    : null} */}
                <div className='col-xs-12'>
                    <CheckBoxField
                        label={'MSME Available'}
                        checked={objectData.msmeAvailable}
                        onChange={e => inputChange(e, 'msmeAvailable')}
                    />
                </div>
            </div>
            <div className='row' style={{marginBottom:'12px'}}>
                <div className="col-12 text-center">
                    {
                        !window.location.href.includes('/external') ?
                            <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('close')}>Close</button>
                            :
                            <a href={WEBSITE}> <button type="button" style={{fontSize:'16px'}} className="cred-btn">Close</button></a>
                    }
                    <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('back')}>Back</button>
                    <button className="cred-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('save')}>Save and Continue</button>
                </div>
            </div>
        </div>
    )
}

export default AddUi;